import { render, staticRenderFns } from "./popovers.vue.js?vue&type=template&id=3dce99d4&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=template&id=3dce99d4&vue3"
import script from "./popovers.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=script&lang=js&vue3"
export * from "./popovers.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports